import $ from 'jquery'

export default () => {
    $('.js-overlay-activate').click(function(e) {
        const instance = $(this).attr('data-overlay-control')

        if ($('.js-overlay-activate-conditional-check').length > 0) {
            const $test = $(this).parents('.js-fake-form-conditional-context').find('.js-overlay-activate-conditional-test')

            if ($test.is(':valid')) {
                const $overlayInstance = $(`.js-overlay[data-overlay-instance=${instance}]`)
                $overlayInstance.addClass('is-active').find('.js-overlay-focus').focus()
                
                $('html').toggleClass('overflow-hidden')
    
                e.preventDefault()
            }
        } else {
            const $overlayInstance = $(`.js-overlay[data-overlay-instance=${instance}]`)
            $overlayInstance.addClass('is-active').find('.js-overlay-focus').focus()
            
            $('html').addClass('overflow-hidden')
        }
    })

    $('.js-overlay-deactivate').click(function() {
        $(this).parents('.js-overlay').removeClass('is-active')
        $('html').removeClass('overflow-hidden')
    })
}